
// Events
(function(window, document) {

    // Different DOM for this block
    const moveProductTestimonial = (screen) => {

        let testimonial_content = document.querySelector('.product-content-testimonial .product-nav-target');
        let testimonial_nav = document.querySelector('.product-nav-testimonial .product-nav-target');

        if(testimonial_nav !== undefined){
            if(screen == "desktop" || screen == "laptop"){
                let testimonial_body = document.querySelector('.product-content-testimonial .product-testimonial');
                if (testimonial_body) {
                    moveElementTo(testimonial_body, testimonial_nav);
                }
            } else {
                let testimonial_body = document.querySelector('.product-nav-testimonial .product-testimonial');
                if (testimonial_body) {
                    moveElementTo(testimonial_body, testimonial_content);
                }
            }
        }
    }

    const moveElementTo = (source, destination) => {
        let dummy = document.createElement('span')
        source.before(dummy)
        destination.before(source)
        dummy.replaceWith(destination)
    }

    const activeProductAccordion = (tab) => {
        let activeTab = document.querySelector('.tab-pane.active');
        if (!activeTab) {
            let productPresentationButton = document.querySelector('.block-presentation');
            if (productPresentationButton) {
                productPresentationButton.classList.add('active');
            }
            let blockPresentationTab = document.querySelector('#sheet_accordion_presentation');
            if (blockPresentationTab) {
                blockPresentationTab.classList.add('show');
            }
            let blockPresentationBody = document.querySelector('#sheet_accordion_presentation .accordion-button');
            if (blockPresentationBody) {
                blockPresentationBody.classList.add('collapsed');
            }
        }
    }

    const closeProductAccordion = () => {

        document.querySelectorAll('#accordion-product-content .tab-pane.active .accordion-button').forEach(tabButton => {
            tabButton.classList.add('collapsed');
        });
        document.querySelectorAll('#accordion-product-content .tab-pane').forEach(tabPane => {
            tabPane.classList.remove('active');
        });
        document.querySelectorAll('#accordion-product-content .accordion-collapse').forEach(tabBody => {
            tabBody.classList.remove('show');
        });
    }

    const handleDeviceChange = (newClass) => {

        if( document.body.classList.contains("desktop")){
            moveProductTestimonial('desktop');
        }
        if( document.body.classList.contains("laptop")){
            moveProductTestimonial('laptop');
        }
        if( document.body.classList.contains("tablet")){
            moveProductTestimonial('tablet');
            activeProductAccordion('prestation');
        }
        if( document.body.classList.contains("mobile")
        && window.lastDevice !== "mobile" ){
            moveProductTestimonial('mobile');
            closeProductAccordion();
        }
    };

    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.attributeName === 'class') {
                const bodyClass = document.body.className;
                handleDeviceChange(bodyClass);
            }
        }
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
    });

    // Init
    const initialClass = document.body.className;
    handleDeviceChange(initialClass);

})(window, document);


// Events
document.addEventListener('DOMContentLoaded', function() {

    // Scroll in product
    if (document.body.classList.contains('body-product')
    || document.body.classList.contains('body-circuit')) {

        // to top after click | Tablet + Mobile
        let myCollapsible = document.getElementById('accordion-product-content')
        if (myCollapsible) {
            myCollapsible.addEventListener('hidden.bs.collapse', function (event) {
                accordionScrollToNav(event.srcElement);
            });
            myCollapsible.addEventListener('shown.bs.collapse', function (event) {
                accordionScrollToNav(event.srcElement);
            });
        }

        // to bottom forms
        document.querySelectorAll('.prices-wrapper .btn').forEach(button => {
            button.addEventListener('click', function() {
                hashScrollToTab(button);
                openBootstrapTab(button);
            });
        });

    };

    // Scroll when searching
    if (document.body.classList.contains('body-products')) {
        const urlParams = new URLSearchParams(window.location.search);
        const idStanding = urlParams.get("idStanding");
        const idRegion = urlParams.get("idRegion");
        const idActivite = urlParams.get("idActivite");
        // to top list
        if (urlParams.has("idStanding") || urlParams.has("idRegion") || urlParams.has("idActivite")) {
            scrollToClass('.section-products');
        }
    };

    if (document.body.classList.contains('body-landing')) {

        // to bottom forms
        document.querySelectorAll('.text-cta .btn').forEach(button => {
            button.addEventListener('click', function() {
                hashScrollToTab(button);
                openBootstrapTab(button);
            });
        });

    };

    // For #link from price calendar
    window.addEventListener("hashchange", function(event) {
        hashToForm();
    });
    if (window.location.hash) {
        hashToForm();
    }

    function hashToForm() {
        let hash = window.location.hash; // #formtab_estimate or #formtab_book (or #bookModal)
        // Open Modal -> Open Tab too
        if( hash.match(/bookModal/) ){
            hash = '#formtab_book';
        }
        // Open Tab
        if( hash.match(/formtab/) ){
            event.preventDefault();
            let element = document.querySelector('.forms-tabs-header');
            let button = document.querySelector('.prices-wrapper .btn[data-bs-target="'+hash+'"]');
            if( button ){
                toggleCtaPrimary(button);
                hashScrollToTab(button);
                openBootstrapTab(button);
            }
        }
    }

    function openBootstrapTab(button) {
        let buttonOpenTab = button.dataset.bsTarget;
        const triggerTabEl = document.querySelector('.forms-tabs-header button[data-bs-target="'+buttonOpenTab+'"]');

        if (triggerTabEl) {
            const tabInstance = window.Tab.getOrCreateInstance(triggerTabEl);
            tabInstance.show();
        } else {
            console.log('Trigger element not found for:', buttonOpenTab);
        }

        let hasCalendar = document.querySelector('.modal-calendar');
        if (hasCalendar) {
            closeCalendarModal();
        }
    }

    function toggleCtaPrimary(buttonActive) {
        let buttons = document.querySelectorAll('.prices-wrapper .btn');
        buttons.forEach(button => {
            button.classList.remove('btn-primary');
            button.classList.add('btn-secondary');
        });
        buttonActive.classList.remove('btn-secondary');
        buttonActive.classList.add('btn-primary');
    }

    // Change State of price buttons
    document.querySelectorAll('.forms-tabs-header button').forEach(button => {

        button.addEventListener('shown.bs.tab', function (event) {

            let buttons = document.querySelectorAll('.prices-wrapper .btn');
            let buttonOpenTab = event.target.dataset.bsTarget; //event.relatedTarget; // previous active tab

            let buttonActive = document.querySelector('.prices-wrapper .btn[data-bs-target="'+buttonOpenTab+'"]');
            buttons.forEach(button => {
                button.classList.remove('btn-primary');
                button.classList.add('btn-secondary');
            });
            buttonActive.classList.remove('btn-secondary');
            buttonActive.classList.add('btn-primary');
        });

    });

    function closeCalendarModal(){
        let calendar = document.querySelector('.modal-calendar');
        const modal = window.Modal.getOrCreateInstance(calendar);
        modal.hide();
    }

    function accordionScrollToNav(button) {
        let buttonScrollTo = button.dataset.scrollto;
        let targetElement = document.querySelector(buttonScrollTo);
        let headerHeight = document.querySelector('#header').offsetHeight;

        // Only apply scroll for tablet and mobile
        if (document.body.classList.contains('tablet')
        || document.body.classList.contains('mobile')) {

            if (targetElement) {
                // Define an offset to adjust the scroll position so the title is visible
                const offset = headerHeight;
                // Calculate the element's position relative to the document (including current scroll)
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
                smoothScrollTo(elementPosition, 400);
            }
        }
    }

    function scrollToClass(targetClass) {
        const targetElement = document.querySelector(targetClass);
        const header = document.querySelector('#header');
        const logo = document.querySelector('.header-logo');

        if (!targetElement || !header) return;

        const screenWidth = window.innerWidth;
        let tabPadding = 0;

        // Tab padding by screen size
        if (screenWidth >= 1292) tabPadding = 32;
        else if (screenWidth >= 1024) tabPadding = 24;
        else if (screenWidth >= 768) tabPadding = 0;

        const headerHeight = header.offsetHeight;
        const logoHeight = logo ? logo.offsetHeight : 0;

        let offset;
        if (screenWidth >= 1024) {
            // Desktop & Laptop: header shrink and logo disappears
            offset = headerHeight + logoHeight - tabPadding;
        } else {
            // Tablet & Mobile: header is usually fixed, we just subtract a little padding
            offset = headerHeight - tabPadding;
        }

        let elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

        // Scroll to top first, then scroll to target after layout settles
        window.scrollTo(0, 0);

        // Scroll after a short delay to let layout stabilize
        setTimeout(() => {
            const newHeaderHeight = header.offsetHeight;
            const newTargetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - (newHeaderHeight - tabPadding);
            smoothScrollTo(newTargetPosition, 400);
        }, 100);

    }

    function hashScrollToTab(button) {
        let buttonScrollTo = button.dataset.scrollto;
        let targetElement = document.querySelector(buttonScrollTo);
        let headerHeight = document.querySelector('#header').offsetHeight;

        if (targetElement) {
            const offset = headerHeight;
            const tabPadding = 16;
            const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset - tabPadding;
            smoothScrollTo(elementPosition, 400);
        }
    }

    function smoothScrollTo(targetPosition, duration = 600) {
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        let startTime = null;

        function animationScroll(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
            window.scrollTo(0, run);

            if (timeElapsed < duration) requestAnimationFrame(animationScroll);
        }

        // Ease-in-out function for a smooth effect
        function easeInOutQuad(t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        }

        requestAnimationFrame(animationScroll);
    }


});
